module.exports = __webpack_public_path__ + "img/隨緣自強3 的副本.5ac724d4.jpg";